import { render, staticRenderFns } from "./info.vue?vue&type=template&id=33eef8ec&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33eef8ec')) {
      api.createRecord('33eef8ec', component.options)
    } else {
      api.reload('33eef8ec', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=33eef8ec&", function () {
      api.rerender('33eef8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/user-manage/usage-record/info.vue"
export default component.exports